import { render } from "./PaymentDetailSection.vue?vue&type=template&id=ccfcec50"
import script from "./PaymentDetailSection.vue?vue&type=script&lang=js"
export * from "./PaymentDetailSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__